module.exports = __webpack_public_path__ + "img/gb2202.prt.530232a6.jpg";